import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'
import pictureserv from './module/pictureserv'
import clientaccountserv from './module/clientaccountserv'
import clientserv from './module/clientserv'
import realtimemonitorsubscribeserv from './module/realtimemonitorsubscribeserv'
import vehiclemaintenanceplanserv from './module/vehiclemaintenanceplanserv'
import businessnoteserv from './module/businessnoteserv'
import clientinfoserv from './module/clientinfoserv'
import insurancechannelserv from './module/insurancechannelserv'
import potentialvehicleinfoserv from './module/potentialvehicleinfoserv'
import saleschannelserv from './module/saleschannelserv'
import vehiclebrandserv from './module/vehiclebrandserv'
import vehicledriverinfoserv from './module/vehicledriverinfoserv'
import vehicleinfoserv from './module/vehicleinfoserv'
import vehicleinfogroupserv from './module/vehicleinfogroupserv'
import vehiclemodelserv from './module/vehiclemodelserv'
import vehicleownerinfoserv from './module/vehicleownerinfoserv'
import vehicletypeserv from './module/vehicletypeserv'
import combovehicleinfoserv from './module/combovehicleinfoserv'
import groupserv from './module/groupserv'
import alarmanalysisserv from './module/alarmanalysisserv'
import attentionvehicleanalysisserv from './module/attentionvehicleanalysisserv'
import offlineanalysisserv from './module/offlineanalysisserv'
import tracksintegrityanalysisserv from './module/tracksintegrityanalysisserv'
import tripserv from './module/tripserv'
import unlocatedanalysisserv from './module/unlocatedanalysisserv'
import shortmessageserv from './module/shortmessageserv'
import jt808deviceserv from './module/jt808deviceserv'
import netcommandserv from './module/netcommandserv'
import incomeserv from './module/incomeserv'
import outlayserv from './module/outlayserv'
import custompoiserv from './module/custompoiserv'
import monitoredareaserv from './module/monitoredareaserv'
import locatehistoryserv from './module/locatehistoryserv'
import positioningdevicefittingsserv from './module/positioningdevicefittingsserv'
import positioningdevicefittingstypeserv from './module/positioningdevicefittingstypeserv'
import positioningdeviceinfoserv from './module/positioningdeviceinfoserv'
import siminfoserv from './module/siminfoserv'
import accesstokenserv from './module/accesstokenserv'
import authorizeserv from './module/authorizeserv'
import installorderserv from './module/installorderserv'
import maintainorderserv from './module/maintainorderserv'
import renewalorderserv from './module/renewalorderserv'
import renewalpayorderserv from './module/renewalpayorderserv'
import backupdbserv from './module/backupdbserv'
import systeminfoserv from './module/systeminfoserv'
import systemlogserv from './module/systemlogserv'
import cpuminutelyserv from './module/cpuminutelyserv'
import memminutelyserv from './module/memminutelyserv'
import noticeserv from './module/noticeserv'
import noticeinfoserv from './module/noticeinfoserv'
import rmfreeserv from './module/rmfreeserv'
import wechatminiprogramcfgserv from './module/wechatminiprogramcfgserv'
import mediaplatformserv from './module/mediaplatformserv'
import webadminerrorlogserv from './module/webadminerrorlogserv'
import webtablecolumnsserv from './module/webtablecolumnsserv'
import accountserv from './module/accountserv'
import usergroupserv from './module/usergroupserv'
import roleserv from './module/roleserv'
import permissionserv from './module/permissionserv'
import userserv from './module/userserv'
import positioningdevicetypeserv from './module/positioningdevicetypeserv'
import drivercarddataresultserv from './module/drivercarddataresultserv'
import allinpayorderserv from './module/allinpayorderserv'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    user,
    app,
    pictureserv,
    clientaccountserv,
    clientserv,
    realtimemonitorsubscribeserv,
    vehiclemaintenanceplanserv,
    businessnoteserv,
    clientinfoserv,
	insurancechannelserv,
    potentialvehicleinfoserv,
	saleschannelserv,
    vehiclebrandserv,
    vehicledriverinfoserv,
    vehicleinfoserv,
    vehicleinfogroupserv,
    vehiclemodelserv,
    vehicleownerinfoserv,
    vehicletypeserv,
    combovehicleinfoserv,
    groupserv,
    alarmanalysisserv,
    attentionvehicleanalysisserv,
    offlineanalysisserv,
    tracksintegrityanalysisserv,
    tripserv,
    unlocatedanalysisserv,
    shortmessageserv,
    jt808deviceserv,
    netcommandserv,
    incomeserv,
    outlayserv,
    custompoiserv,
    monitoredareaserv,
    locatehistoryserv,
	positioningdevicefittingsserv,
    positioningdevicefittingstypeserv,
    positioningdeviceinfoserv,
    siminfoserv,
    accesstokenserv,
    authorizeserv,
    installorderserv,
	maintainorderserv,
    renewalorderserv,
	renewalpayorderserv,
    backupdbserv,
    systeminfoserv,
    systemlogserv,
    cpuminutelyserv,
    memminutelyserv,
    noticeserv,
    noticeinfoserv,
	rmfreeserv,
    wechatminiprogramcfgserv,
    mediaplatformserv,
    webadminerrorlogserv,
    webtablecolumnsserv,
    accountserv,
    usergroupserv,
    roleserv,
    permissionserv,
    userserv,
	positioningdevicetypeserv,
    drivercarddataresultserv,
	allinpayorderserv,
  }
})
